

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLSUBDEPARTMENTS= createAsyncThunk(
  "getAllSubDepartments/getAllSubDepartments",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllSubDepartmentsSlice = createSlice({
  name: "getAllSubDepartmentsSlice",
  initialState: {
    getAllSubDepartments: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllSubDepartments: (state) => {
        state.getAllSubDepartments.loading = false
        state.getAllSubDepartments.error = false
        state.getAllSubDepartments.data = []
        state.getAllSubDepartments.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLSUBDEPARTMENTS.fulfilled, (state, action) => {
      state.getAllSubDepartments = {
        ...state.getAllSubDepartments,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSUBDEPARTMENTS.pending, (state, action) => {
      state.getAllSubDepartments = {
        ...state.getAllSubDepartments,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSUBDEPARTMENTS.rejected, (state, action) => {
      state.getAllSubDepartments = {
        ...state.getAllSubDepartments,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllSubDepartmentsAction = {
    GETALLSUBDEPARTMENTS,
};

export { getAllSubDepartmentsAction };
export default getAllSubDepartmentsSlice.reducer;
export const {setInitialStateOfgetAllSubDepartments} = getAllSubDepartmentsSlice.actions
